export const mapBackendMessage = (backendMessage) => {
  if (typeof backendMessage !== "string" || !backendMessage) {
    return ""; // Return an empty string or a default message if it's not a valid string
  }

  const messageMapping = {
    "enter the correct password": "Enter the correct password",
    "user not found": "No account found with this email address.",
    "server error": "We encountered an issue. Try again later.",
    "invalid email/phone number. please enter a valid email/phone number.":
      "Login failed. Invalid email or phone number",
    "enter the correct otp": "Invalid OTP. Enter the correct OTP",
    "email send with otp": "Otp send to email. Check your email",
    "done successfully": "Otp verified successfully",
    "email does not exist": "Email does not exist",
    "email must be unique":
      "This email is already registered. Please use a different one.",
  };

  const normalizedMessage = backendMessage
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ")
    .replace(/[^\w\s\/\.\-]/g, "");

  return messageMapping[normalizedMessage] || backendMessage;
};

export const manualMappings = {
  "/admin/sub-brand": "Sub Brand Management",
  "/admin/wholesaler": "Wholesaler Management",
  "/admin/bar": "Bar & Club Management",
  "/admin/customer": "Customer Management",
};

export const manualMappingWholesaler = {
  "/wholesaler/product": "Product Management",
  "/wholesaler/bar": "Partnered Bars & Clubs",
};
